// Кнопка «скопировать»: код для входа, ссылка на него, список ссылок целиком.
//
// Жила в разделе настроек частным компонентом ровно до того дня, когда копирование
// понадобилось ВТОРОМУ разделу — «Людям», где ссылку для входа теперь выдают прямо из
// карточки человека и пачкой из реестра. Переезд в общий слой, а не копия рядом: две кнопки
// копирования означали бы два разных ответа на отказ буфера обмена
// (`.claude/rules/duplication-guard.md`).
//
// Отказ буфера — не тупик и не ошибка: код и ссылка написаны рядом на экране, их можно выделить
// мышью. Поэтому вместо красного сообщения кнопка говорит, что делать дальше.

import { useEffect, useState } from 'react';

import { RiCheckLine, RiFileCopyLine } from '@remixicon/react';

import * as Button from '@/shared/ui/button';

/** Сколько держится подтверждение на кнопке. Меньше — человек не успевает прочитать. */
const ДЕРЖИМ_ОТВЕТ = 2000;

export function КнопкаКопирования({
  что,
  подпись,
  вид = 'stroke',
}: {
  /** Значение, которое уедет в буфер: сам код или ссылка на него. */
  что: string;
  подпись: string;
  вид?: 'filled' | 'stroke';
}) {
  const [ответ, setОтвет] = useState<'нет' | 'скопировано' | 'не вышло'>('нет');

  // Подтверждение гаснет само. Без этого кнопка навсегда остаётся «Скопировано», и следующее
  // нажатие выглядит как несработавшее.
  useEffect(() => {
    if (ответ === 'нет') {
      return;
    }
    const таймер = setTimeout(() => setОтвет('нет'), ДЕРЖИМ_ОТВЕТ);
    return () => clearTimeout(таймер);
  }, [ответ]);

  async function скопировать() {
    try {
      await navigator.clipboard.writeText(что);
      setОтвет('скопировано');
    } catch {
      setОтвет('не вышло');
    }
  }

  return (
    <div className='flex flex-col gap-1'>
      <Button.Root
        type='button'
        variant='neutral'
        mode={вид}
        size='xxsmall'
        onClick={() => void скопировать()}
      >
        <Button.Icon as={ответ === 'скопировано' ? RiCheckLine : RiFileCopyLine} />
        {ответ === 'скопировано' ? 'Скопировано' : подпись}
      </Button.Root>
      {ответ === 'не вышло' && (
        <span className='text-paragraph-xs text-text-sub-600'>
          Скопировать не вышло — выделите написанное рядом и скопируйте сами.
        </span>
      )}
    </div>
  );
}
